import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import { useTranslation } from 'react-i18next'
import useAuthStore from '../stores/authStore'
import useUserStore from '../stores/userStore'

const Login = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { error, login, loadUserFromLocalStorage } = useAuthStore()
    const { fetchProfile, profile } = useUserStore()
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')

    useEffect(() => {
        loadUserFromLocalStorage()
    }, [loadUserFromLocalStorage])

    const handleSubmit = async (event) => {
        event.preventDefault()
        const success = await login(email, password)
        if (success) {
            await fetchProfile()

            const role = localStorage.getItem('role')
            if (role === 'admin') {
                navigate('/admin')
                return
            }
            navigate('/')
        } else {
            console.error('Login failed, please try again.')
        }
    }

    return (
        <div>
            <Header />
            <section className="tf-login tf-section">
                <div className="themesflat-container">
                    <div className="row">
                        <div className="col-12">
                            <h2 className="tf-title-heading ct style-1">Đăng nhập</h2>

                            <div className="flat-form box-login-social">
                                <div className="form-inner">
                                    <form onSubmit={handleSubmit}>
                                        <input
                                            id="email"
                                            name="email"
                                            tabIndex="1"
                                            aria-required="true"
                                            required
                                            type="email"
                                            placeholder="Email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />
                                        <input
                                            id="password"
                                            name="password"
                                            tabIndex="2"
                                            aria-required="true"
                                            type="password"
                                            placeholder="Password"
                                            required
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                        <div className="row-form style-1">
                                            <label>
                                                Ghi nhớ tài khoản
                                                <input type="checkbox" />
                                                <span className="btn-checkbox"></span>
                                            </label>
                                        </div>
                                        {error && (
                                            <p className="m-3" style={{ color: '#df4949' }}>
                                                Login failed, please try again.
                                            </p>
                                        )}
                                        <button type="submit" className="sc-button style-2 fl-button pri-3">
                                            <span>Đăng nhập</span>
                                        </button>
                                    </form>
                                </div>
                            </div>

                            <div className="flat-form box-login-email mg-t-37">
                                <div className="box-title-login">
                                    <h5>Bạn chưa có tài khoản ?</h5>
                                </div>

                                <div className="form-inner">
                                    <Link to="/sign-up" className="sc-button style-2 fl-button pri-3">
                                        <span>Đăng ký</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Login
